import styled from 'styled-components';
import { layoutConfig } from '../../utils/commonVariables';

const Main = styled.div`
  position: relative;
  top: ${layoutConfig.navHeight};
  width: 100%;
`;

export default Main;
